/**
 * f12.1: the five stat cards of `review.html`, read from the server's grand
 * total -- the unit currency for one unit, USD for more (adr-12). Budget is
 * "—" with "Finance only" for everyone else.
 */

import type { Review } from '@/api/client';

import { deltaClass, formatDelta, formatMoney } from './reviewFormat';

function Card({ label, bar, value, foot }: { label: string; bar: number; value: string; foot?: React.ReactNode }) {
  return (
    <div className={`card stat-card rv-bar-${bar}`}>
      <div className="stat-top"><span className="stat-label">{label}</span></div>
      <div className="stat-value sm">{value}</div>
      {foot && <div className="stat-foot">{foot}</div>}
    </div>
  );
}

export function ReviewStatCards({ review }: { review: Review }) {
  const figures = review.totals.figures;
  const converting = review.totals.conversion_pending ? ' · Converting…' : '';
  return (
    <div className="grid grid-5 mb-4">
      <Card
        label={`Budget ${review.cycle.fiscal_year}`}
        bar={1}
        value={review.budget_visible ? formatMoney(figures?.budget) : '—'}
        foot={review.budget_visible ? undefined : 'Finance only'}
      />
      <Card
        label={review.cycle.label}
        bar={2}
        value={formatMoney(figures?.current_com)}
        foot={
          figures?.delta_to_last_com ? (
            <>
              <span className={deltaClass(figures.delta_to_last_com)}>{formatDelta(figures.delta_to_last_com)}</span>{' '}
              vs last COM{converting}
            </>
          ) : (
            `No frozen baseline yet${converting}`
          )
        }
      />
      <Card label="Unweighted" bar={3} value={formatMoney(figures?.unweighted)} />
      <Card label="Upside" bar={4} value={formatMoney(figures?.upside)} />
      <Card label="Downside" bar={5} value={formatMoney(figures?.downside)} />
    </div>
  );
}
